import React from 'react';
import { YouTubeEmbed } from '@next/third-parties/google';
import { YouTubeVideoCard, YouTubeVideoCardProps } from '@benzinga/ui';
import LazyLoad from 'react-lazyload';
import styled from '@benzinga/themetron';

export interface YoutubeBlockProps {
  attrs?: {
    url?: string;
  };
  videoId?: string;
  playlistId?: string;
}

export const getYoutubeVideoId = (url: string) => {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

export const YoutubeBlock: React.FC<YoutubeBlockProps> = ({ attrs, playlistId, videoId }) => {
  const youtubeVideoId = videoId || getYoutubeVideoId(attrs?.url || '');

  let embedUrl: string | null = null;
  if (playlistId) {
    embedUrl = `https://www.youtube.com/embed/videoseries?list=${playlistId}`;
  } else if (youtubeVideoId) {
    embedUrl = `https://www.youtube.com/embed/${youtubeVideoId}`;
  }

  if (!embedUrl) return null;

  return (
    <Container className="youtube-block">
      {!playlistId && youtubeVideoId ? (
        <YouTubeEmbed height={270} videoid={youtubeVideoId} width={480} />
      ) : (
        <div className="youtube-iframe-wrapper">
          <LazyLoad offset={600} once>
            <iframe
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              height="270"
              loading="lazy"
              src={embedUrl}
              title="YouTube player"
              width="480"
            />
          </LazyLoad>
        </div>
      )}
    </Container>
  );
};

const Container = styled.div`
  &.youtube-block {
    margin: 1rem 0;
    display: flex;
    justify-content: center;

    .youtube-iframe-wrapper {
      position: relative;
      overflow: hidden;
      width: 100%;
      padding-top: 56.25%;

      > iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
`;

export const YouTubeVideoCardElement: React.FC<YouTubeVideoCardProps> = props => {
  return <YouTubeVideoCard {...props} />;
};
